<template>
  <section class="section Info">
    <div class="container">
      <div class="level">
        <h1 class="title level-left">Videos Niveles</h1>
      </div>
      <div class="card box">
        <div class="grid_inputs">
          <div class="input_wrapper">
            <label>Link inicial</label>
            <input class="input" type="text" placeholder="Link de youtube para inicial" v-model="level_one_link">
          </div>
          <div class="input_wrapper">
            <label>Link primaria</label>
            <input class="input" type="text" placeholder="Link de youtube para primaria" v-model="level_two_link">
          </div>
          <div class="input_wrapper">
            <label>Link secundaria</label>
            <input class="input" type="text" placeholder="Link de youtube para secundaria" v-model="level_three_link">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { firestore } from '@/main'
export default {
  data: () => ({
    infoId: "",
    level_one_link: "",
    level_two_link: "",
    level_three_link: "",
  }),
  mounted () {
    this.getWebInfo()
  },
  methods: {
    getWebInfo () {
      firestore.collection("web").get()
      .then((snap) => {
        snap.forEach((doc) => {
          const {level_one_link, level_two_link, level_three_link} = doc.data()
          this.infoId = doc.id
          this.level_one_link = level_one_link
          this.level_two_link = level_two_link
          this.level_three_link = level_three_link
        })
      })
      .catch(console.error)
    },
    urlValid(url) {
      const p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
      if(url.match(p)){
        return url.match(p)[1]
      }
      return false
    },
    saveLink(obj) {
      firestore.collection("web").doc(this.infoId).update(obj)
      .then((res) => {
        console.log(res)
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
      })
    },
    triggerSave(val, obj) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        if (this.urlValid(val)) this.saveLink(obj)
      }, 1000)
    }
  },
  watch: {
    level_one_link (val) {
      this.triggerSave(val, {
        level_one_link: val
      })
    },
    level_two_link (val) {
      this.triggerSave(val, {
        level_two_link: val
      })
    },
    level_three_link (val) {
      this.triggerSave(val, {
        level_three_link: val
      })
    }
  }
}
</script>

<style lang="sass" scoped>
@import "bulma"
@import '../../assets/css/_variables.sass'
.Info
  h1
    font-size: 20px
  .grid_inputs
    display: grid
    grid-gap: 20px
    grid-template-columns: repeat( auto-fit, minmax(300px, 1fr) )
    .button, .input
      box-sizing: border-box
    .input_wrapper
      label
        font-size: 13px
        margin-bottom: 5px
        display: block
        font-weight: 600
</style>